Vue.filter("arrayFirst", function(array)
{
    return array[0];
});
